import { ComponentProps, ReactNode } from 'react';

import { Button, SelectModal } from '@pukka/ui-components';

interface OutletSelectorHeaderProps<T>
  extends ComponentProps<Exclude<ComponentProps<typeof SelectModal<T>>['header'], undefined | ReactNode>> {}

function OutletSelectorHeader<T>({ items, max }: OutletSelectorHeaderProps<T>) {
  return (
    <SelectModal.Filter>
      <SelectModal.ToggleAll>
        {({ onClick, selected: isAllSelected }) => {
          const limitItems = max < items.size;
          let selectAllText = 'Select All';

          if (isAllSelected) {
            selectAllText = 'Unselect All';
          } else if (limitItems) {
            selectAllText = `Select top ${max}`;
          }

          return (
            <Button variant="secondary" onClick={onClick} className="w-32">
              {selectAllText}
            </Button>
          );
        }}
      </SelectModal.ToggleAll>
    </SelectModal.Filter>
  );
}

export { OutletSelectorHeader };
